// libs
import styled from 'styled-components'
// views
import { TableContent } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/views'
import { TableFieldWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField/views'
// themes
import { colors } from 'themes/index'

export const BasicField = styled(TableFieldWrapper)`
  font-size: 14px;
  display: flex;
  align-items: start;
  padding-top: 4px;
  color: ${colors.gray320};
`

export const RiskWrapper = styled.div`
    display: flex;
    gap: 12px;

    ${TableContent} {
        padding: 0;
    }

    ${TableFieldWrapper} {
        min-width: 200px;
        max-width: 200px;
        padding-right: 12px;

        .switch-wrapper {
            > div > div {
                height: 32px;
                justify-content: center;
            }
        }

        .MuiInputLabel-formControl,
        .responseTypeLabel {
            display: none;
        }

        .MuiFormControl-root > div {
            margin-top: 0;
        }
    }

    .MuiInputAdornment-root {
        display: none;
    }

    .MuiInput-input {
        font-size: 14px;
    }

    .MuiInputBase-input {
        padding: 0;
        height: 32px;
    }

    .react-select__single-value {
        font-size: 14px;
        white-space: normal;
    }
}
`

export const UniqId = styled.div`
  display: flex;
  width: 200px;
  font-size: 14px;
  border-right: 1px solid darkgray;
`

export const Parent = styled(TableFieldWrapper)`
  flex-direction: column;
  align-items: start;
  gap: 0;
`
